import { ShowImage } from './ShowImage';
export default ShowImage;